import React, { useState } from "react";
import { useLanguage } from "../context/LanguageContext";
import { useParams, useNavigate } from "react-router-dom";
import products from "../data/products.json";
import "../pages/Selling/style.css";

export const ProductPage = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const { id } = useParams();

  const product = products.find((p) => p.id === id);

  const [selectedImage, setSelectedImage] = useState(
    product?.image?.[0] || null
  );

  const [showSidebar, setShowSidebar] = useState(false);
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => setSidebarOpen((prev) => !prev);

  if (!product) {
    return (
      <div className="selling-page-shell product-not-found-shell">
        <button className="selling-back-button" onClick={() => navigate(-1)}>
          ← {t("back_to_home")}
        </button>

        <div className="not-found-card">
          <h1>{t("product_not_found")}</h1>
        </div>
      </div>
    );
  }

  return (
    <div className="selling-page-shell product-detail-shell">
      <div className="selling-ambient selling-ambient-one"></div>
      <div className="selling-ambient selling-ambient-two"></div>
      <div className="selling-light-beam"></div>
      <div className="selling-blue-diamond"></div>
      <div className="selling-outline selling-outline-one"></div>
      <div className="selling-outline selling-outline-two"></div>
      <div className="selling-dots"></div>

      {sidebarOpen && <div className="backdrop" onClick={toggleSidebar} />}
      {showSidebar && (
        <div className="backdrop" onClick={() => setShowSidebar(false)} />
      )}

      <button className="selling-back-button" onClick={() => navigate(-1)}>
       <img src="/arrow1.png" alt=""className="backhomebutton" />
      </button>

      <main className="product-detail-layout">
        <section className="mainsellingdiv product-gallery-card">
          <div className="galleryimages product-detail-gallery">
            <div className="thumbnails">
              {product.image.map((img, index) => (
                <button
                  key={index}
                  className={`thumbnail-button ${
                    selectedImage === img ? "selected" : ""
                  }`}
                  onClick={() => setSelectedImage(img)}
                  aria-label={`${t("thumbnail")} ${index + 1}`}
                >
                  <img
                    src={img}
                    alt={`${t("thumbnail")} ${index + 1}`}
                    className="thumbnail"
                  />
                </button>
              ))}
            </div>

            <div className="prodcustimagesdiv detail-main-image-area">
              <div className="product-stage-platform"></div>

              {selectedImage && (
                <div
                  className="zoom-container"
                  style={{ backgroundImage: `url(${selectedImage})` }}
                  onMouseMove={(e) => {
                    const { left, top, width, height } =
                      e.currentTarget.getBoundingClientRect();

                    const x = ((e.clientX - left) / width) * 100;
                    const y = ((e.clientY - top) / height) * 100;

                    e.currentTarget.style.backgroundSize = "200%";
                    e.currentTarget.style.backgroundPosition = `${x}% ${y}%`;
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.backgroundSize = "100%";
                    e.currentTarget.style.backgroundPosition = "center";
                  }}
                >
                  <img
                    src={selectedImage}
                    alt={t("main_image")}
                    className="mainimage invisible-img"
                  />
                </div>
              )}
            </div>
          </div>
        </section>

        <aside className="sellinginfodiv product-detail-info-card">
          <div className="productinfo">
            <span className="product-category-pill">Smart BAG product</span>

            <h1 className="product-title">{product.name}</h1>

            <div className="product-info-grid">
              <div className="product-info-box">
                <span>{t("model_label")}</span>
                <strong>{product.model}</strong>
              </div>

              <div className="product-info-box">
                <span>{t("quantity_label")}</span>
                <strong>{product.quantity}</strong>
              </div>

              <div className="product-info-box">
                <span>{t("layer_count")}</span>
                <strong>{product.layers}</strong>
              </div>

              <div className="product-info-box">
                <span>{t("country_of_origin")}</span>
                <strong>{product.country}</strong>
              </div>
            </div>

            <div className="product-price-card">
              <span>{t("product_price")}</span>
              <strong>֏1800</strong>
            </div>

            <div className="product-details-summary">
              <div className="features premium-features">
                <p>{t("features_good")}</p>
                <p>{t("features_ideal")}</p>
                <p>{t("features_long")}</p>
              </div>

              <div className="availability">
                {t("quantity_available")}
              </div>

              <div className="bottom-row">
                <button className="gallery-btn" onClick={toggleSidebar}>
                  {t("our_social_media")}
                </button>

                <button
                  className="details-button"
                  onClick={() => setShowSidebar(true)}
                >
                  {t("characteristics_and_description")}
                </button>
              </div>
            </div>
          </div>
        </aside>
      </main>

      <div className={`social-sidebar ${sidebarOpen ? "open" : ""}`}>
        <span className="close-btn" onClick={toggleSidebar}>
          ×
        </span>

        <h3>{t("social_media")}</h3>

        <ul className="social-links">
          <li>
            <a
              href="https://www.facebook.com/profile.php?id=100026704725346&locale=ru_RU"
              target="_blank"
              rel="noopener noreferrer"
            >
              Facebook
            </a>
          </li>

          <li>
            <a
              href="https://www.instagram.com/"
              target="_blank"
              rel="noopener noreferrer"
            >
              Instagram
            </a>
          </li>
        </ul>
      </div>

      {showSidebar && (
        <div className="sidebar-overlay" onClick={() => setShowSidebar(false)}>
          <div className="sidebar" onClick={(e) => e.stopPropagation()}>
            <button
              className="close-btn"
              onClick={() => setShowSidebar(false)}
            >
              ×
            </button>

            <h2>{t("characteristics_and_description")}</h2>

            <p>
              <strong>{t("items_in_package")}</strong> {product.packageCount} {t("quantity_short")}
            </p>

            <p>
              <strong>{t("model_label")}</strong> {product.model}
            </p>

            <p>
              <strong>{t("product_material")}</strong> {t("prod_material")}
            </p>

            <p>
              <strong>{t("layer_count")}</strong> {product.layers}
            </p>

            <p>
              <strong>{t("country_of_origin")}</strong> {product.country}
            </p>

            <p>
              <strong>{t("description_label")}</strong> {t("description_prod")}
            </p>
          </div>
        </div>
      )}
    </div>
  );
};

export default ProductPage;

